import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { BrandingProvider } from './contexts/BrandingContext';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <BrandingProvider>
                <AuthProvider>
                    <PermissionProvider>
                        <App />
                    </PermissionProvider>
                </AuthProvider>
            </BrandingProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// Register PWA service worker (เปิดใช้ beforeinstallprompt + เพิ่มลงหน้าจอหลัก)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then((reg) => console.log('SW registered:', reg.scope))
            .catch((err) => console.warn('SW register failed:', err));
    });
}
